<app-test-connaissances
  [img]="img"
  [reponses]="reponses"
  [partieSuivante]="partieSuivante"
  [question]="question"
></app-test-connaissances>
